import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';

import { useCallContext } from '@gem/call/CallView/CallView.context';
import { CloseButton } from '@gem/call/CallView/Shared/CloseButton/CloseButton';
import { IcClose32Icon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';

import styles from './RightPanelHeader.styles.m.css';

export const RightPanelHeader = observer(() => {
  const { call } = useCallContext();
  const { t } = useTranslation();

  const hideMembers = useCallback(() => {
    call.viewState.hideMembers();
  }, []);

  return (
    <div className={styles.headerContainer}>
      <div className={styles.content}>
        <div className={styles.title}>{t('common_participants')}</div>
      </div>
      <div>
        <CloseButton
          Icon={IcClose32Icon}
          onClick={hideMembers}
        />
      </div>
    </div>
  );
});
